module.exports = __webpack_public_path__ + "media/images/2_3_6-98f67ec969adbf49c05760d728690018.png";